import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import axios from 'axios';
import Url from './config';
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import BaiduMap from 'vue-baidu-map'
Vue.use(ElementUI)
Vue.config.productionTip = false;
Vue.prototype.axios = axios;	
Vue.prototype.Url = Url;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
Vue.use(BaiduMap,{
  ak:'b5iR5lkGLGNFbyeDXXXbogYGSGluF2xd'		//使用申请的百度地图秘钥
})